import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import { RenewalPage } from "@/config/app-constant";
import { APPLICATION } from "@/constants";

import { useCoverForContext } from "../../../provider/cover-for.provider";

function FormDescriptionSection() {
  const { cmsData } = useCoverForContext();
  const { editPartyTypePlaceholder } = cmsData.overlayArea[0];

  if (!(APPLICATION === RenewalPage && editPartyTypePlaceholder?.["0"]))
    return null;
  return (
    <div className="mt-spacing-l">
      <RichText
        richText={editPartyTypePlaceholder["0"].content}
        className="text-text-on-primary font-proxima-nova text-xs font-normal leading-[27px]"
      />
    </div>
  );
}

export default FormDescriptionSection;
